// eslint-disable-next-line
export const isValidToken = (jwt) => {
  const payloadBase64 = jwt.split('.')[1];
  const payload = JSON.parse(window.atob(payloadBase64));
  const { exp } = payload;
  const now = new Date();
  return now.getTime() <= exp * 1000;
};

export const parseAuthorities = (jwt) => {
  const payloadBase64 = jwt.split('.')[1];
  const payload = JSON.parse(window.atob(payloadBase64));
  const { authorities } = payload;
  return authorities || [];
};
